import React from "react";
import { Card } from "antd";
import { useTranslation } from "react-i18next";
import monoGenoma from "../assets/mono-genoma.png";
import "./process-detail/styles.scss";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="unknown-interview">
      <Card
        className="card"
        title={
          <div style={{ textAlign: "center" }}>
            <img src={monoGenoma} alt="genomin" />
            <h1>{t("frontvint__not_found_title")}</h1>
          </div>
        }
      >
        <span>{t("frontvint__not_found_content")}</span>
      </Card>
    </div>
  );
};

export default NotFound;
